import { draft } from '$utils/services/formDraftService'
import { ResidenceRecommendationService } from '$domain/model/recommendation/recommendation.model'
import { residenceFormDraftName, ResidenceFormSteps } from '$views/RecommendationsForms/ResidenceForm/ResidenceForm'
import { createResidenceRecommendationService } from '$domain/model/recommendation/recommendation.manager'
import { tagManager } from '$infrastructure/tagManager/tagManager'

export const createRecommendationService = async (caretakerId?: string) => {
  const locationFormData = draft.get(residenceFormDraftName)[ResidenceFormSteps.locationStep]
  const dateFormData = draft.get(residenceFormDraftName)[ResidenceFormSteps.dateStep]
  const residentFormData = draft.get(residenceFormDraftName)[ResidenceFormSteps.residentStep]
  const careFormData = draft.get(residenceFormDraftName)[ResidenceFormSteps.careStep] || ''

  const service: ResidenceRecommendationService = {
    address: locationFormData.address,
    latitude: locationFormData.latitude,
    longitude: locationFormData.longitude,
    province: locationFormData.province,
    serviceDates: dateFormData,
    residentId: residentFormData.id,
    companionship: careFormData.companionship,
    sanityAttention: careFormData.sanityAttention,
    cleaness: careFormData.cleaness,
    transport: careFormData.transport,
    extraInformation: careFormData.extraInformation,
    caretakerId: caretakerId,
  }

  await createResidenceRecommendationService(service)
  tagManager.push({
    event: 'publishoffer',
    serviceType: 'Corto',
    offerType: 'recomendación',
  })
  draft.unsetAll()
}



// WEBPACK FOOTER //
// ./src/services/nursingHome/recommendation/recommendation.service.ts